import apiClient from '../axios.js';

export const autoTagRuleService = {
  /**
   * 查詢自動貼標規則列表
   * @param {Object} params - 查詢參數
   * @param {boolean} params.isActive - 是否啟用（選填）
   * @param {string} params.tagName - 標籤名稱（選填）
   * @param {number} params.priority - 優先順序（選填）
   * @returns {Promise<Object>} 規則列表
   */
  getAutoTagRules: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
    if (params.tagName) queryParams.append('tagName', params.tagName);
    if (params.priority !== undefined) queryParams.append('priority', params.priority);

    const queryString = queryParams.toString();
    const url = `/auto-tag-rules${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get(url);
    return response;
  },

  /**
   * 查詢自動貼標規則詳情
   * @param {string} ruleId - 規則 ID
   * @returns {Promise<Object>} 規則詳情
   */
  getAutoTagRule: async (ruleId) => {
    const response = await apiClient.get(`/auto-tag-rules/${ruleId}`);
    return response;
  },

  /**
   * 建立自動貼標規則
   * @param {Object} ruleData - 規則資料
   * @returns {Promise<Object>} 建立結果
   */
  createAutoTagRule: async (ruleData) => {
    const response = await apiClient.post('/auto-tag-rules', ruleData);
    return response;
  },

  /**
   * 更新自動貼標規則
   * @param {string} ruleId - 規則 ID
   * @param {Object} ruleData - 規則資料
   * @returns {Promise<Object>} 更新結果
   */
  updateAutoTagRule: async (ruleId, ruleData) => {
    const response = await apiClient.put(`/auto-tag-rules/${ruleId}`, ruleData);
    return response;
  },

  /**
   * 刪除自動貼標規則
   * @param {string} ruleId - 規則 ID
   * @returns {Promise<Object>} 刪除結果
   */
  deleteAutoTagRule: async (ruleId) => {
    const response = await apiClient.delete(`/auto-tag-rules/${ruleId}`);
    return response;
  },

  /**
   * 執行自動貼標規則
   * @param {string} ruleId - 規則 ID
   * @returns {Promise<Object>} 執行結果
   */
  executeAutoTagRule: async (ruleId) => {
    const response = await apiClient.post(`/auto-tag-rules/${ruleId}/execute`);
    return response;
  },

  /**
   * 預覽符合規則條件的會員列表
   * @param {string} ruleId - 規則 ID
   * @param {Object} params - 查詢參數
   * @param {number} params.page - 頁碼
   * @param {number} params.pageSize - 每頁筆數
   * @returns {Promise<Object>} 會員列表
   */
  previewMatchingMembers: async (ruleId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.pageSize) queryParams.append('pageSize', params.pageSize);

    const queryString = queryParams.toString();
    const url = `/auto-tag-rules/${ruleId}/preview-members${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get(url);
    return response;
  },

  /**
   * 啟用/停用自動貼標規則
   * @param {string} ruleId - 規則 ID
   * @param {boolean} isActive - 是否啟用
   * @returns {Promise<Object>} 更新結果
   */
  toggleAutoTagRule: async (ruleId, isActive) => {
    const response = await apiClient.patch(`/auto-tag-rules/${ruleId}/toggle`, { isActive });
    return response;
  }
};
